import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { CommonPlayerPreview } from '#src/components/commonCard/CommonPlayerPreview/index.tsx';

import type { CommonCardsGrid_commonPlayer } from './__generated__/types.graphql.ts';

export const commonCardsGridFragment = gql`
  fragment CommonCardsGrid_commonPlayer on CommonPlayer {
    id
    anyPlayer {
      slug
    }
    ...CommonPlayerPreview_commonPlayer
  }
  ${CommonPlayerPreview.fragments.commonPlayer}
` as TypedDocumentNode<CommonCardsGrid_commonPlayer>;
